module.exports = __webpack_public_path__ + "assets/time-range.4a869bcb.svg";